<template>
  <v-container style="max-width:1300px" class="mt-8">
    <v-row dense>
      <DataCard
        v-for="d in data"
        :key="d.id"
        :d="d"/>
    </v-row>
   <v-pagination
   :value="curPage"
   :length="count"
   :total-visible="9"
   @input="click"
   color="primary"
   class="mt-8"
  ></v-pagination>
 </v-container>
</template>

<script>
import DataCard from '../components/DataCard.vue'

export default {
  components: {
    DataCard
  },
  data () {
    return {
      data: [],
      count: 0,
      curPage: 1
    }
  },
  created () {
    this.all()
  },
  methods: {
    all: function () {
      this.axios.get('maps/')
        .then(response => {
          this.data = response.data.results
          this.count = Math.ceil(response.data.count / process.env.VUE_APP_PAGE_SIZE)
        })
    },
    click (page) {
      var offset = process.env.VUE_APP_PAGE_SIZE * (page - 1)
      this.axios.get('maps/', { params: { limit: process.env.VUE_APP_PAGE_SIZE, offset: offset } })
        .then(response => {
          this.data = response.data.results
          this.curPage = page
          this.$vuetify.goTo(0)
        })
    }
  }
}
</script>

<style scoped>

</style>
